var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"triangle-component",style:('background:'+_vm.gradient+'; transform:'+_vm.transform)})}
var staticRenderFns = []

export { render, staticRenderFns }